module.exports = __webpack_public_path__ + "img/m-vac-h.2541a9d4.svg";